export default "/fr/_next/static/assets/images/favicon-fr.c95e73bb4385013bd048120130910f20.png";